import { Navigate, useParams, useRoutes } from "react-router-dom";

import ArticleEditPage from "./article/edit";
import ArticleListPage from "./article/list";
import ProviderListPage from "./list";
import TrackingRoutes from "./tracking/routes";

export default () =>
  useRoutes([
    { path: "/:providerCode/:slug/:tracking", element: <TrackingRoutes/> },
    { path: "/:providerCode/:slug", element: <WithParameters component={ArticleEditPage}/> },
    { path: "/:providerCode", element: <WithParameters component={ArticleListPage}/> },
    { path: "/", element: <WithParameters component={ProviderListPage}/> },
    { path: "/*", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
